<template>
  <div>
    <h4 class="card-title mb-3">Takaful Product Report Summary</h4>

    <div class="row">
      <div class="col-6">
        <div class="input-group mb-4 d-flex flex-row p2">
          <label style="margin-right: 10px">Product: </label>
          <div class="form-outline ">
            <select class="form-control" :value="product_id" @change="handleChange">
              <option
                v-for="(product, index) in allProducts"
                :key="index"
                :value="product.id"
                >{{ product.name }}</option
              >
            </select>
          </div>
          <button
            class="btn btn-primary mr-2"
            @click="onfilterProduct()"
          >
            Filter
          </button>
        </div>
      </div>

      <div class="col-6">
        <h5>
          <b>Total: B$ {{ takaful_total_price }} </b>
        </h5>
        <h5>
          <b>Total Points: {{ takaful_total_points }} </b>
        </h5>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="col-6">
        <label><b>Date From</b></label>
        <input type="date" class="form-control" :value="dateFrom" @change="handleDateChange($event, 1)" />
      </div>
      <div class="col-6">
        <label><b>Date To</b></label>
        <input type="date" class="form-control" :value="dateTo"  @change="handleDateChange($event, 2)" />
      </div>
    </div>

    <br />

    <div class="text-left">
      {{
        dateFromFormatted != null && dateToFormatted != null
          ? `Reported Date from ${dateFromFormatted} to ${dateToFormatted}`
          : ""
      }}
    </div>

    <div class="text-right">
      <button
        class="btn btn-rounded btn-primary mr-2"
        style="width: 150px;"
        @click="filterSearchTakaful()"
      >
        Filter
      </button>
      <button
        class="btn btn-rounded btn-primary"
        style="width: 150px;"
        @click="resetFilter(3)"
      >
        Reset
      </button>
    </div>

    <div class="table-responsive">
      <table
        id="takaful_product_summary_table"
        class="display table table-striped table-bordered report-table"
        style="width:100%; text-align: center;"
      >
        <thead>
          <tr>
            <th>No.</th>
            <th>Name</th>
            <th>Points Redeemed</th>
            <th>Points Redeemed in B$</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(takaful, index) in takafulProducts" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ takaful.name }}</td>
            <td>{{ takaful.points_redeemed }}</td>
            <td>{{ takaful.total_price }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    product_id: {
      required: true
    },

    allProducts: {
      type: Array,
      required: true
    },

    takafulProducts: {
      type: Array,
      required: true
    },

    onfilterProduct: {
      type: Function,
      required: true
    },

    filterSearchTakaful: {
      type: Function,
      required: true
    },

    resetFilter: {
      type: Function,
      required: true
    },

    takaful_total_price: {
      required: false,
      default: 0
    },

    takaful_total_points: {
      required: false,
      default: 0
    },

    dateFrom: {
      type: String,
      required: false,
      default: null
    },

    dateTo: {
      type: String,
      required: false,
      default: null
    },

    dateFromFormatted: {
      type: String,
      required: false,
      default: null
    },

    dateToFormatted: {
      type: String,
      required: false,
      default: null
    },
  },
  
  return() {
    data: {
      
    }
  },

  methods: {
    handleChange(event) {
      const newValue = event.target.value;
      this.$emit('onProductSelected', newValue);
    },

    handleDateChange(event, type) {
      const newValue = event.target.value;
      this.$emit('onChangeDate', newValue, type);
    },
  }
}
</script>
